import ApplicationAdapter from './application';

const createPayload = (data) => ({ data });

class PreAssignmentAdapter extends ApplicationAdapter {
  createRecord(store, type, snapshot) {
    const url = this.buildURL(type.modelName, null, snapshot, 'createRecord');
    const json = this.serialize(snapshot, { includeId: true });

    const version = json.data.attributes.version;
    const packageId = json.data.attributes['package-id'];
    const sellerId = json.data.relationships?.seller?.data?.id;

    const attributes = { version };

    if (sellerId) {
      attributes.seller_id = sellerId;
    }

    if (packageId) {
      attributes.package_id = packageId;
    }

    const data = createPayload({ attributes });
    return this.ajax(url, 'POST', { data });
  }

  updateRecord(store, type, snapshot) {
    const url = this.buildURL(type.modelName, snapshot.id, snapshot, 'updateRecord');
    const json = this.serialize(snapshot, { includeId: true });

    const facts = json.data['pre-assignment-facts'];
    const data = createPayload({ ['pre-assignment-facts']: facts });

    return this.ajax(url, 'PATCH', { data });
  }
}

export default PreAssignmentAdapter;
